import { Component, ErrorInfo, ReactNode } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Box, Button, Heading, Text } from '@chakra-ui/react';

interface Props extends WithTranslation {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundaryComponent extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
    // Error is already captured in state via getDerivedStateFromError
  }

  public render() {
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <Box p={5} textAlign="center">
          <Heading as="h1">{t('error.boundary.title')}</Heading>
          <Text color="semantics.error">{this.state.error?.message}</Text>
          <Button onClick={() => window.location.reload()}>{t('error.boundary.reload')}</Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withTranslation()(ErrorBoundaryComponent);
